import { ctw } from '@/common/utils/ctw/ctw';
import type { HTMLAttributes } from 'react';
import { forwardRef } from 'react';

export const AlertTitle = forwardRef<HTMLParagraphElement, HTMLAttributes<HTMLHeadingElement>>(
  ({ className, ...props }, ref) => (
    <h5
      ref={ref}
      className={ctw('mb-1 font-medium leading-none tracking-tight', className)}
      {...props}
    />
  ),
);

AlertTitle.displayName = 'AlertTitle';
